// extracted by mini-css-extract-plugin
module.exports = {"page_title":"styles_page_title__1RWIf"};